import { render, staticRenderFns } from "./sourceAnalysis.vue?vue&type=template&id=ef80543e&scoped=true&"
import script from "./sourceAnalysis.vue?vue&type=script&lang=js&"
export * from "./sourceAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./sourceAnalysis.vue?vue&type=style&index=0&id=ef80543e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef80543e",
  null
  
)

export default component.exports